import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { restRequest } from '../../../Helpers/RequestHelper';
import OverlayLoader from '../../../Components/Loader/OverlayLoader';
import Form from '../../../Components/Form/Form';
// import Field from '../../../Components/Form/Field/Field'
import FormAction from '../../../Components/Form/FormAction';
import { getObjFromLS } from '../../../Helpers/LocalStorage';
import './InvoicePreference.css';
import { checkError } from '../../../Helpers/AuthHelper';
import { t } from 'i18next';

class InvoicePreference extends Component {
  state = {
    loading: true,
    salesPref: {
      invFormat: '',
    },
    terms: '',
    isSubmitting: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    this.setState({ loading: true });
    await restRequest('get', 'numberPreferences/invoice')
      .then((res) => {
        this.setState({
          salesPref: {
            invFormat: res.preferences.invFormat,
          },
          terms: res.terms,
        });
      })
      .catch((error) => {
        checkError(error, this.props.handleToast);
        this.setState({ loading: false });
      });
    this.setState({ loading: false });
  }

  toggleInvoiceFormatChange(value) {
    let invAddedFormat = value.target.value;
    this.setState((state) => ({
      salesPref: {
        ...state.salesPref,
        invFormat: invAddedFormat,
      },
    }));
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let { invFormat } = this.state.salesPref;
    this.setState({ isSubmitting: true });
    restRequest('put', 'numberPreferences/invoice', {
      status: {
        invFormat: invFormat,
      },
      terms: this.state.terms,
    })
      .then(() => {
        this.setState({ isSubmitting: false });
        this.props.handleToast(
          t('common.invoice_prefix_preference_updated_successfully'),
          'success'
        );
      })
      .catch((error) => {
        this.setState({ isSubmitting: false });
        checkError(error, this.props.handleToast);
        //this.props.handleToast(error, "error")
      });
  };
  /*
    salesTermsContent() {
      return (
        <div>
          <Field
            name="Terms & Conditions"
            id="terms"
            type="textarea"
            value={this.state.terms}
            placeholder="Terms & Conditions"
            handleChange={this.handleChange}
          />
        </div>
      )
    }
  */
  renderActionButtons() {
    // return (
    //   <FormAction disabled={this.state.isSubmitting} onCancel={() => this.props.history.push('/settings')} />
    // )
    let permissions = getObjFromLS('role').permissions;
    if (!permissions.superAccess) {
      if (permissions.PreferenceEdit) {
        return (
          <FormAction
            disabled={this.state.isSubmitting}
            onCancel={() => this.props.history.push('/settings')}
          />
        );
      }
    }
    if (permissions.superAccess) {
      return (
        <FormAction
          disabled={this.state.isSubmitting}
          onCancel={() => this.props.history.push('/settings')}
        />
      );
    }
  }
  renderInvoicePreference() {
    return (
      <Form onSubmit={this.handleSubmit}>
        <div className="po-pref-component">
          {this.state.loading && <OverlayLoader />}
          <div>{t('common.change_invoice_prefix_as_needed')}</div>
          {/*<hr className="pref--hr" />*/}
          <label className="list-table--checkbox-lable">
            <div className="sale-return-preference--label-text semi-bold">
              {t('common.invoice_prefix')}
            </div>
            <input
              style={{ width: '50px' }}
              name="invFormat"
              value={this.state.salesPref.invFormat}
              type="text"
              //pattern='[0-9]{0,5}'
              maxLength={3}
              required
              onChange={(value) => this.toggleInvoiceFormatChange(value)}
            />
          </label>
          {this.renderActionButtons()}
        </div>
      </Form>
    );
  }

  render() {
    return this.renderInvoicePreference();
  }
}

export default withRouter(InvoicePreference);
